import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 申明全局仓库函数
    Flag: localStorage.getItem('Flag'),
    proxy: localStorage.getItem('proxy'),
    promote: localStorage.getItem('promote')
  },
  getters: {
    // 外部调用$store.getters.
    Flag (state) {
      return state.Flag
    },
    proxy (state) {
      return state.proxy
    },
    promote (state) {
      return state.promote
    }
  },
  mutations: {
    // 外部使用this.$store.commit('','')调用
    Flag (state, payload) {
      state.Flag = payload
    },
    proxy (state, payload) {
      state.proxy = payload
    },
    promote (state, payload) {
      state.promote = payload
    }
  }
})



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 